import { DriveDocument } from '@/api/types/drive'
import { WorkstationDocument } from '@/api/types/workstation'

type Resource = WorkstationDocument | DriveDocument

export const getExistingResources = (resources: Resource[] | null): Resource[] => {
  if (!resources) {
    return []
  }
  return resources.filter((resource) => !resource.deleted)
}

export const getActiveResources = (resources: Resource[] | null): Resource[] => {
  return getExistingResources(resources).filter((resource) => resource.status !== 'error')
}

export const driveIsPreparing = (drive: DriveDocument): boolean => {
  return drive.status === 'preparing'
}

export const getPreparingDrives = (drives: DriveDocument[] | null): DriveDocument[] => {
  return (getActiveResources(drives) as DriveDocument[]).filter(driveIsPreparing)
}

// TODO deprecated empty status
// always have explicit status set on drive
export const driveIsReady = (drive: DriveDocument): boolean => {
  return !drive.status || drive.status === 'ready'
}

export const getReadyDrives = (drives: DriveDocument[]): DriveDocument[] => {
  return (getExistingResources(drives) as DriveDocument[]).filter(driveIsReady)
}
